import { render, staticRenderFns } from "./CapacitationsTopics.vue?vue&type=template&id=6946bccd&"
import script from "./CapacitationsTopics.vue?vue&type=script&lang=js&"
export * from "./CapacitationsTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports